import { render, staticRenderFns } from "./Carddots.vue?vue&type=template&id=770ef6c0&"
import script from "./Carddots.vue?vue&type=script&lang=js&"
export * from "./Carddots.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports